module.exports = __webpack_public_path__ + "static/img/kr.6735ebc3.svg";